import React from "react";
import styles from "./styles.less";
import PropTypes from "prop-types";

const OrStrip = ({ orTitle }) => {
  return <div className={styles.strip}>{orTitle}</div>;
};

OrStrip.propTypes = {
  orTitle: PropTypes.string
};

export default OrStrip;



// WEBPACK FOOTER //
// ./src/components/common/ContactUs/OrStrip/OrStrip.js